"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteEditor = void 0;
var react_1 = __importStar(require("react"));
var editor_web_1 = require("@21st-night/editor-web");
var cards_web_1 = require("@21st-night/cards-web");
var Editor_1 = require("../Editor");
var NoteEditorToolbar_1 = require("./NoteEditorToolbar");
var core_1 = require("@21st-night/core");
var NoteEditor = function (_a) {
    var _b = _a.plugins, plugins = _b === void 0 ? [] : _b, onSubmitCardForm = _a.onSubmitCardForm, onRemoveCardLink = _a.onRemoveCardLink, onClickPreviewCard = _a.onClickPreviewCard, onClickStudyCard = _a.onClickStudyCard, other = __rest(_a, ["plugins", "onSubmitCardForm", "onRemoveCardLink", "onClickPreviewCard", "onClickStudyCard"]);
    var _c = core_1.useFirebase(), db = _c.db, storage = _c.storage, functions = _c.functions;
    var CardCreationPlugin = react_1.useMemo(function () {
        return cards_web_1.createCardCreationPlugin({
            EditorProps: {
                db: db,
                storage: storage,
                functions: functions,
                imageUrl: process.env.REACT_APP_IMGIX_URL,
            },
        });
    }, [db, storage, functions]);
    var CardLinkPlugin = react_1.useMemo(function () {
        return cards_web_1.createCardLinkPlugin({
            onClickPreviewCard: onClickPreviewCard,
            onClickStudyCard: onClickStudyCard,
            onRemoveCardLink: onRemoveCardLink,
        });
    }, [onClickPreviewCard, onClickStudyCard]);
    return (react_1.default.createElement(Editor_1.Editor, __assign({}, other, { plugins: __spreadArray([CardCreationPlugin, CardLinkPlugin], __read(plugins)), toolbar: false, hoveringToolbar: false }),
        react_1.default.createElement(cards_web_1.CardCreationPluginEditable, { onSubmitCreateCard: onSubmitCardForm, EditorProps: {
                db: db,
                storage: storage,
                functions: functions,
                imageUrl: process.env.REACT_APP_IMGIX_URL,
                plugins: [CardCreationPlugin],
            } },
            react_1.default.createElement(NoteEditorToolbar_1.NoteEditorToolbar, null),
            react_1.default.createElement(editor_web_1.EditorHoveringToolbar, null,
                react_1.default.createElement(cards_web_1.EditorCreateCardButton, { onRemoveCardLink: onRemoveCardLink })))));
};
exports.NoteEditor = NoteEditor;
//# sourceMappingURL=NoteEditor.js.map